export const BOOKING_COUNT_KEYS = [
  "appliedCount",
  "upcomingAccepted",
  "previouslyAccepted",
  "reservedCount",
  "rejectedCount",
  "waitingListCount",
  "cancelledCount"
];

export const DEFAULT_QUERY_LIMIT = 10;
export const DEFAULT_QUERY_OFFSET = 0;

export const ORDER_BY_CONFIG = {
  COLUMN: "shifts.startTime",
  ASC: "ASC",
  DESC: "DESC"
};

export const TIMESHEET_ORDER_BY_CONFIG = {
  COLUMN: "scheduledStartTime",
  DIRECTION: "desc"
};
